import React, { useState } from 'react';
import { formatMoney } from '../../utils/formatters';
import { saveHrPosition, deleteHrPosition } from '../../services/api';

/* Справочник должностей со ставкой по умолчанию. Пока должность была
   свободным текстом, разбивка ФОТ по должностям почти ничего не показывала:
   после переноса из Excel большинство людей числилось просто «Сотрудник». */

const PositionsModal = ({ positions, onClose, onChanged }) => {
  const [list, setList] = useState(positions);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', default_rate: '', default_pay_type: 'hourly' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const startNew = () => {
    setEditing('new');
    setForm({ name: '', default_rate: '', default_pay_type: 'hourly' });
  };

  const startEdit = (position) => {
    setEditing(position.id);
    setForm({
      name: position.name,
      default_rate: position.default_rate || '',
      default_pay_type: position.default_pay_type,
    });
  };

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await saveHrPosition({
        id: editing === 'new' ? undefined : editing,
        name: form.name,
        default_rate: Number(form.default_rate) || 0,
        default_pay_type: form.default_pay_type,
      });
      setList(result.positions);
      onChanged(result.positions);
      setEditing(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось сохранить должность');
    } finally {
      setBusy(false);
    }
  };

  const remove = async (position) => {
    if (!window.confirm(`Удалить должность «${position.name}»?`)) return;
    setError(null);
    try {
      const result = await deleteHrPosition(position.id);
      setList(result.positions);
      onChanged(result.positions);
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось удалить должность');
    }
  };

  return (
    <div className="ui-modal" onClick={onClose}>
      <div className="ui-modal-box wide" onClick={(e) => e.stopPropagation()}>
        <div className="ui-modal-head">
          <h2>Должности</h2>
          <button className="ui-icon-btn" onClick={onClose} aria-label="Закрыть">×</button>
        </div>

        <p className="ui-dim hr-import-lead">
          Ставка по умолчанию подставляется в карточку нового сотрудника. Переименование
          должности здесь меняет её и у всех, кто на ней числится.
        </p>

        <div className="hr-positions">
          {list.length === 0 && <p className="ui-dim">Справочник пуст.</p>}
          {list.map(position => (
            <div className="hr-position-row" key={position.id}>
              <div>
                <span className="hr-position-name">{position.name}</span>
                <span className="ui-dim">
                  {position.default_pay_type === 'salary' ? 'оклад ' : ''}
                  {position.default_rate ? formatMoney(position.default_rate) : 'ставка не задана'}
                  {position.default_pay_type === 'hourly' && position.default_rate ? ' / час' : ''}
                  {' · '}{position.employees} чел.
                </span>
              </div>
              <div className="hr-position-actions">
                <button className="ui-btn-ghost" onClick={() => startEdit(position)}>Изменить</button>
                <button className="ui-btn-ghost" onClick={() => remove(position)}>Удалить</button>
              </div>
            </div>
          ))}
        </div>

        {editing ? (
          <form className="ui-form hr-position-form" onSubmit={save}>
            <div className="ui-grid">
              <div className="ui-field wide">
                <label>Название</label>
                <input value={form.name} onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Пармастер" />
              </div>
              <div className="ui-field">
                <label>Тип оплаты</label>
                <select value={form.default_pay_type} onChange={(e) => setForm(f => ({ ...f, default_pay_type: e.target.value }))}>
                  <option value="hourly">Почасовая</option>
                  <option value="shift">Посменная</option>
                  <option value="salary">Оклад</option>
                </select>
              </div>
              <div className="ui-field">
                <label>Ставка по умолчанию</label>
                <input
                  type="number"
                  value={form.default_rate}
                  onChange={(e) => setForm(f => ({ ...f, default_rate: e.target.value }))}
                />
              </div>
            </div>
            <div className="ui-modal-actions">
              <button type="button" className="ui-btn-ghost" onClick={() => setEditing(null)}>Отмена</button>
              <button type="submit" className="ui-btn-primary" disabled={busy}>Сохранить</button>
            </div>
          </form>
        ) : (
          <div className="ui-modal-actions">
            <button type="button" className="ui-btn-ghost" onClick={onClose}>Закрыть</button>
            <button type="button" className="ui-btn-primary" onClick={startNew}>Добавить должность</button>
          </div>
        )}

        {error && <div className="ui-inline-error">{error}</div>}
      </div>
    </div>
  );
};

export default PositionsModal;
